import App from './App'
import { createSSRApp } from 'vue'
import * as Pinia from 'pinia'
import '@/el-ui/index.js'
import config from '@/config/index.js'
import translate from 'i18n-jsautotranslate'

translate.setUseVersion2();
translate.selectLanguageTag.show=false;
translate.service.use('client.edge')
translate.nomenclature.append("chinese_simplified","english",
	`中文=中文`)
translate.listener.start();

uni.$config.set(config);

export function createApp() {
  const app = createSSRApp(App)
  app.use(Pinia.createPinia())
  app.config.globalProperties.$translate=translate;
  return {
    app,
	Pinia
  }
}